
export default {
    name: 'LeeAlert',
    data() {
        return {
            isShow: true,
            thetype:'warning'

        }
    },
    watch: {
        type: {
            immediate: true,
            handler(value) {
                let types=['primary','success','danger','info','warning','leecolor']
                let fi=types.filter(function(el) {
                    return el.indexOf(value)>-1;
                })
                if(fi.length<1){
                    this.thetype="info"
                }else{
                    this.thetype=value
                }
            }
        },
    },
    methods: {
        hide(){
            this.isShow=false;
            this.$emit('close')
        }
    },
    props: {
        title: {
            type: String,
            default: '提示文字' //默认default
        },
        type: {
            type: String,
            default: 'info' //默认default
        },
        closeable: {
            type: Boolean,
            default: false //默认default
        },
        showIcon: {
            type: Boolean,
            default: false //默认default
        }
    }
};
